module.exports = __webpack_public_path__ + "static/media/act01.e1f22404.m4a";